import { createFileRoute, Link, Outlet } from "@tanstack/react-router"
import { Page } from "@/components/page"
import { Typography } from "@/components/ui/typography"
import { useUserType } from "@/hooks/use-user-type"
import { cn } from "@/lib/utils"

export const Route = createFileRoute("/_authed/account")({
  component: AccountLayout,
})

function AccountLayout() {
  const { isProfessional, isIndividual } = useUserType()

  return (
    <Page
      headerSlot={
        <Typography as="h1" size="2xl">
          Account Settings
        </Typography>
      }
    >
      {/* Tabs */}
      <nav className="flex gap-3 mb-6">
        <Link
          to="/account/profile"
          className={cn(
            "px-4 py-2 rounded-full text-sm font-medium transition",
            "bg-muted text-muted-foreground hover:bg-muted/80",
            "[&.active]:bg-primary [&.active]:text-white",
          )}
        >
          Profile
        </Link>
        {isProfessional && (
          <Link
            to="/account/organization"
            className={cn(
              "px-4 py-2 rounded-full text-sm font-medium transition",
              "bg-muted text-muted-foreground hover:bg-muted/80",
              "[&.active]:bg-primary [&.active]:text-white",
            )}
          >
            Organization
          </Link>
        )}
        {isIndividual && (
          <Link
            to="/account/emergency-contacts"
            className={cn(
              "px-4 py-2 rounded-full text-sm font-medium transition",
              "bg-muted text-muted-foreground hover:bg-muted/80",
              "[&.active]:bg-primary [&.active]:text-white",
            )}
          >
            Emergency Contacts
          </Link>
        )}
        <Link
          to="/account/security"
          className={cn(
            "px-4 py-2 rounded-full text-sm font-medium transition",
            "bg-muted text-muted-foreground hover:bg-muted/80",
            "[&.active]:bg-primary [&.active]:text-white",
          )}
        >
          Security
        </Link>
      </nav>

      <Outlet />
    </Page>
  )
}
